var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8CF26"
    },
    d: "M10,44.708c1.103,0,2-0.897,2-2V42H8v0.708C8,43.81,8.897,44.708,10,44.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8B26"
    },
    d: "M10,39c-0.737,0-1.375,0-1.722,1h3.443C11.375,39,10.737,39,10,39z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8CF26"
    },
    cx: 24,
    cy: 9.708,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8B26"
    },
    d: "M8,12c0.265,0,0.519-0.041,0.707,0.147L11,14.293v-1.586C11,12.155,11.448,12,12,12h1 c0.551,0,1-0.741,1-1.292v-4C14,6.156,13.551,6,13,6H3C2.449,6,2,6.156,2,6.708v4C2,11.259,2.449,12,3,12H8z M4,8h8v2H4V8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8B26"
    },
    d: "M28,39c-0.737,0-1.375,0-1.722,1h3.443C29.375,39,28.737,39,28,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8CF26"
    },
    d: "M46,44.708c1.103,0,2-0.897,2-2V42h-4v0.708C44,43.81,44.897,44.708,46,44.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8B26"
    },
    d: "M46,39c-0.737,0-1.375,0-1.722,1h3.443C47.375,39,46.737,39,46,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66CEDB"
    },
    d: "M40.694,13.816l-1.539-1.539l-3.323,4.985c-0.132,0.197-0.329,0.342-0.557,0.407l-7,2.146 C28.186,19.841,28.093,20,28,20H18c-1.654,0-3,1.053-3,2.708V31h2v-7h2v7h4v-7h-1v-2h4v2h-1v7h4v-7.292 c0-0.4,0.238-0.762,0.606-0.919l6.743-2.89L40.694,13.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8CF26"
    },
    d: "M28,44.708c1.103,0,2-0.897,2-2V42h-4v0.708C26,43.81,26.897,44.708,28,44.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8B26"
    },
    d: "M51,2H38c-1.654,0-3,1.053-3,2.708v10.198l3.168-4.752c0.166-0.249,0.436-0.411,0.733-0.44 c0.3-0.024,0.594,0.076,0.806,0.288l3,3c0.346,0.346,0.391,0.891,0.107,1.288l-5,7c-0.106,0.149-0.252,0.412-0.42,0.484L34.871,23 H35c0,1,1.346,3,3,3h13c1.654,0,3-1.638,3-3.292v-18C54,3.053,52.654,2,51,2z M51,23H40v-2h11V23z M51,19h-8v-2h8V19z M51,15h-6v-2 h6V15z M51,11h-8V9h8V11z M51,7H38V5h13V7z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,15.708c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S20.691,15.708,24,15.708z M24,5.708c2.206,0,4,1.794,4,4 s-1.794,4-4,4s-4-1.794-4-4S21.794,5.708,24,5.708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.586,14l3.707,3.561c0.191,0.191,0.447,0.22,0.707,0.22c0.129,0,0.259-0.061,0.383-0.113 C12.756,17.514,13,17.112,13,16.708v-3c1.654,0,3-1.346,3-3v-4C16,5.053,14.654,4,13,4H3C1.346,4,0,5.053,0,6.708v4 C0,12.362,1.346,14,3,14H7.586z M2,10.708v-4C2,6.156,2.449,6,3,6h10c0.551,0,1,0.156,1,0.708v4C14,11.259,13.551,12,13,12h-1 c-0.552,0-1,0.155-1,0.708v1.586l-2.293-2.147C8.519,11.959,8.265,12,8,12H3C2.449,12,2,11.259,2,10.708z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,0H38c-2.757,0-5,1.951-5,4.708V16.24L27.86,18H18c-2.757,0-5,1.951-5,4.708V31H9v2h29v-2h-7v-6.633l2.078-0.744 C33.451,26.013,35.506,28,38,28h13c2.757,0,5-2.536,5-5.292v-18C56,1.951,53.757,0,51,0z M29.606,22.789 C29.238,22.946,29,23.307,29,23.708V31h-4v-7h1v-2h-4v2h1v7h-4v-7h-2v7h-2v-8.292C15,21.053,16.346,20,18,20h10 c0.093,0,0.186-0.159,0.275-0.184l7-2.073c0.228-0.065,0.425-0.246,0.557-0.444l3.323-5.004l1.539,1.53l-4.345,6.078 L29.606,22.789z M54,22.708C54,24.362,52.654,26,51,26H38c-1.654,0-3-2-3-3h-0.129l2.523-1.227 c0.168-0.072,0.313-0.262,0.42-0.411l5-7.037c0.284-0.398,0.239-0.961-0.107-1.306l-3-3.009c-0.212-0.212-0.506-0.317-0.806-0.293 c-0.298,0.029-0.567,0.189-0.733,0.438L35,14.905V4.708C35,3.053,36.346,2,38,2h13c1.654,0,3,1.053,3,2.708V22.708z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 5,
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 9,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 13,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 17,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 21,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,49h-6c-2.757,0-5,1.951-5,4.708V56h2v-2.292C22,52.053,23.346,51,25,51h6c1.654,0,3,1.053,3,2.708V56h2v-2.292 C36,50.951,33.757,49,31,49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,49h-6c-2.757,0-5,1.951-5,4.708V56h2v-2.292C40,52.053,41.346,51,43,51h6c1.654,0,3,1.053,3,2.708V56h2v-2.292 C54,50.951,51.757,49,49,49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,49H7c-2.757,0-5,1.951-5,4.708V56h2v-2.292C4,52.053,5.346,51,7,51h6c1.654,0,3,1.053,3,2.708V56h2v-2.292 C18,50.951,15.757,49,13,49z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30.708,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,42.708c0,2.206,1.794,4,4,4s4-1.794,4-4V42h2v-2h-2.142c-0.447-2-2-3.146-3.858-3.146c-2.206,0-4,1.648-4,3.854V42.708 z M12,42.708c0,1.103-0.897,2-2,2s-2-0.897-2-2V42h4V42.708z M10,39c0.737,0,1.375,0,1.722,1H8.279C8.625,39,9.263,39,10,39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,46.708c2.206,0,4-1.794,4-4V42h2v-2h-2.142c-0.447-2-2-3.146-3.858-3.146c-2.206,0-4,1.648-4,3.854v2 C24,44.914,25.794,46.708,28,46.708z M30,42.708c0,1.103-0.897,2-2,2s-2-0.897-2-2V42h4V42.708z M28,39c0.737,0,1.375,0,1.722,1 h-3.443C26.625,39,27.263,39,28,39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,42.708c0,2.206,1.794,4,4,4s4-1.794,4-4V42h2v-2h-2.142c-0.447-2-2-3.146-3.858-3.146c-2.206,0-4,1.648-4,3.854 V42.708z M48,42.708c0,1.103-0.897,2-2,2s-2-0.897-2-2V42h4V42.708z M46,39c0.737,0,1.375,0,1.722,1h-3.443 C44.625,39,45.263,39,46,39z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationSvgrepoCom);
export default __webpack_public_path__ + "static/media/presentation-svgrepo-com.60a8ffc224cf4e2ac6f37968e4279ad3.svg";
export { ForwardRef as ReactComponent };